import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { routes } from "./routes";
import { setPage } from "./redux/actions/Page";
import { Online } from "./pages/Online/Online";

export const OnlineMain = () => {
    const dispatch = useDispatch();

    const listener = useCallback(
        (event: any) => {
            if ((event.data?.isActualCommunicationOnlineData) && event.data?.data) {
                const data = event.data.data;
                if (data.sessionId && data.route === routes.online) {
                    dispatch(setPage(routes.online, {sessionId: data.sessionId, link: data.link, serviceType: data.serviceType}));
                }
            }
        },
        []
    );

    useEffect(() => {
        try {
            if (window.addEventListener) {
                window.postMessage("communicationOnlineLoad", "*");
                window.addEventListener("message", listener, false);
            }

            return () => window.removeEventListener("message", listener);
        } catch (err) {
            console.error("Error Listener: ", err);
        }
    }, [listener]);

    return <Online />;
}